<template>
  <BoardView id="Article" :title="article.title || $t('title')">
    <FormArticleJoint
      v-if="hasFetchedRecord"
      :article.sync="article"
      @save="saveArticle" />
  </BoardView>
</template>

<script>
import { actions, getters } from '@utils'
import { assoc, equals, path } from 'rambda'
import BoardSingle from '@mixins/BoardSingle'
import FormArticleJoint from '@forms/FormArticleJoint'
import Meta from '@mixins/Meta'
import { pluckId } from '@utils/collections'
import { scrollToHash } from '@router/smoothScroll'

export default {
  mixins: [
    Meta(path(['article', 'topic'])),
    BoardSingle('article', {
      factory() {
        const { query } = this.$store.getters

        return {
          facts: query('fact', { articleId: this.recordId }),
          laptops: query('articleLaptop', { articleId: this.recordId }),
          sections: query('section', { articleId: this.recordId })
            .map(section => assoc(
              'facts',
              query('fact', { sectionId: section.id }),
              section,
            )),
          // specs: query('articleSpec', { articleId: this.recordId }),
        }
      },
      redirectTo: null,
    }),
  ],
  components: {
    FormArticleJoint,
  },
  computed: {
    laptops() {
      return this.query('articleLaptop', { articleId: this.recordId })
    },
    ...getters(),
  },
  methods: {
    async saveArticle(record) {
      await this.save(record)
      // TODO: revisit the logic for sections
      // const article = this.recordBound
      // const belongsToArticle = {
      //   articleId: article.id,
      //   ...this.hasRole('>=ADMIN')
      //     ? {}
      //     : { userId: this.authUser.id },
      // }

      // if (!this.article.specs.some(spec => !spec.id)) return

      // const specs = await this.FIND_ARTICLE_SPEC(belongsToArticle)

      // this.article.specs = this.article.specs
      //   .map(spec => ({
      //     ...spec,
      //     id: specs
      //       .find(currentSpec => currentSpec.specTypeId === spec.specTypeId)?.id || null,
      //   }))
    },
    ...actions(
      'FETCH_ARTICLE_LAPTOP',
      'FETCH_FACT',
      'FETCH_FILE',
      'FETCH_SECTION',
      'FETCH_SPEC',
      'FETCH_SITE',
      'SET_IS_SAVING_ARTICLE',
    ),
  },
  watch: {
    hasFetchedRecord() {
      this.LOAD(async () => {
        const belongsToArticle = { articleId: this.recordId }

        await this.FETCH_SECTION(belongsToArticle)

        const sections = this.query('section', belongsToArticle)
        const sectionsImageFileIds = pluckId('imageFileId', sections)

        const article = this.recordBound

        await Promise.all([
          this.FETCH_ARTICLE_LAPTOP(belongsToArticle),
          this.FETCH_FILE({
            id: {
              $in: [
                article.imageFileId,
                ...sectionsImageFileIds,
              ].filter(Boolean),
            },
          }),
          this.FETCH_SECTION(belongsToArticle),
          this.FETCH_SPEC({
            isDesktop: false,
            laptopCount: { $ne: 0 },
            $limit: 500,
          }),
        ])

        const sectionIds = pluckId('id', this
          .query('section', { articleId: article.id }))

        return this.FETCH_FACT({
          $or: [
            belongsToArticle,
            sectionIds.length
              ? [{ sectionId: { $in: sectionIds } }]
              : [],
          ],
        })
      })
    },
    isSaving: {
      immediate: true,
      handler(isSaving) {
        if (isSaving === this.isSavingArticle) return
        this.SET_IS_SAVING_ARTICLE(isSaving)
      },
    },
    'recordBound.criteria'(criteria) {
      if (equals(this.article.criteria, criteria)) return
      this.article.criteria = criteria
    },
    isLoaded: {
      handler(isLoaded) {
        if (!isLoaded || !this.$route.hash) return

        setTimeout(() => {
          scrollToHash(this.$route.hash)
        }, 6000)
      },
    },
  },
}
</script>

<style lang="scss">
#ArticlesAdd {
  .BoardView-title {
    text-align: center;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Edit Article"
  }
}
</i18n>
